<mat-card class="login-card">
  <div class="card-header">
    <h1 *ngIf="(isMinorThanTablet | async).matches" class="title">Tenha o controle do seu <br> carnê em um único lugar</h1>
    <h2>Acesse sua conta:</h2>
  </div>

  <form #form="ngForm" (submit)="handleContinuar($event)" class="card-content">
    <mat-form-field class="fullwidth" [class.error-margin]="inputPassword.touched && inputPassword?.errors" appearance="outline">
      <mat-label>Senha</mat-label>
      <input
        id="inputPassword"
        name="inputPassword"
        type="password"
        #inputPassword="ngModel"
        [(ngModel)]="senha"
        matInput
        placeholder="Senha" 
        required
        [type]="showPassword ? 'text' : 'password'">
        <button mat-icon-button matSuffix type="button" (click)="handleShowPassword()" [attr.aria-label]="'Esconder senha'" [attr.aria-pressed]="showPassword">
          <mat-icon class="suffix-icon" matSuffix>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      <mat-error *ngIf="inputPassword.touched && inputPassword?.getError('required')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        Este campo é obrigatório!
      </mat-error>
      <mat-error *ngIf="inputPassword.touched && inputPassword?.getError('networkError')">
        <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
        A senha não está correta
      </mat-error>
    </mat-form-field>

    <button 
      type="submit"
      mat-flat-button
      class="btn-continue"
      [disabled]="form.invalid || loading">
      <mat-icon *ngIf="loading">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon>
        Entrar
    </button>

    <button type="button" class="link-button" (click)="irParaAlterarSenha()">
      Esqueci minha senha
    </button>
  </form>
</mat-card>